/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {fetchData, getEncryptedRoute, toasterrormsg, useMenuIdPermissions} from '../../../reusable'
import {Tr} from '../../../_metronic/i18n/Tr'

interface AddHotelHeaderProps {
  hotelId: string // Assuming hotelId is of type string, adjust as needed
}
const AddHotelHeader: React.FC<AddHotelHeaderProps> = ({hotelId}) => {
  let t = Tr()
  const location = useLocation()
  const editHotelId = (location.state as any)?.hotelId || ''
  const {menuId} = useMenuIdPermissions()

  const [hotelDetails, setHotelDetails] = useState([])
  // hotel Details api call
  const hotelDetailsApiCall = async () => {
    if (hotelId != '') {
      var param: any = {
        hotelId: hotelId,
      }
    } else if (editHotelId != '') {
      var param: any = {
        hotelId: editHotelId,
      }
    }
    var response: any = await fetchData('vendor/public/hotelDetailsV2', param)

    if (response.status == '200') {
      setHotelDetails(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (editHotelId != '') {
      hotelDetailsApiCall()
    }
  }, [])

  return (
    <>







    
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body'>
          <div className='d-flex overflow-auto'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder my-2 flex-nowrap'>
              <li className='nav-item'>
                {hotelDetails &&
                hotelDetails.length > 0 &&
                hotelDetails[0]['completedSteps'] &&
                hotelDetails[0]['completedSteps']['basicInfo'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      hotelDetails &&
                      hotelDetails.length > 0 &&
                      hotelDetails[0]['completedSteps'] &&
                      hotelDetails[0]['completedSteps']['basicInfo']
                        ? 'bg-primary  text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addhotelbasicinfo/'
                        ? `${
                            hotelDetails &&
                            hotelDetails.length > 0 &&
                            hotelDetails[0]['completedSteps'] &&
                            hotelDetails[0]['completedSteps']['basicInfo']
                              ? 'active_tab bg-success text-white p-0'
                              : 'active p-0'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addhotelbasicinfo/', {menuId:menuId})}
                    state={{hotelId: editHotelId}}
                  >
                    {t('Basic Info')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      hotelDetails &&
                      hotelDetails.length > 0 &&
                      hotelDetails[0]['completedSteps'] &&
                      hotelDetails[0]['completedSteps']['basicInfo']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addhotelbasicinfo/'
                        ? `${
                            hotelDetails &&
                            hotelDetails.length > 0 &&
                            hotelDetails[0]['completedSteps'] &&
                            hotelDetails[0]['completedSteps']['basicInfo']
                              ? 'active_tab text-white'
                              : 'active '
                          }`
                        : ''
                    }`}
                  >
                    {t('Basic Info')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {hotelDetails &&
                hotelDetails.length > 0 &&
                hotelDetails[0]['completedSteps'] &&
                hotelDetails[0]['completedSteps']['location'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      hotelDetails &&
                      hotelDetails.length > 0 &&
                      hotelDetails[0]['completedSteps'] &&
                      hotelDetails[0]['completedSteps']['location']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addhotellocation/'
                        ? `${
                            hotelDetails &&
                            hotelDetails.length > 0 &&
                            hotelDetails[0]['completedSteps'] &&
                            hotelDetails[0]['completedSteps']['location']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addhotellocation/', {menuId:menuId})}
                    state={{hotelId: editHotelId}}
                  >
                    {t('Location')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      hotelDetails &&
                      hotelDetails.length > 0 &&
                      hotelDetails[0]['completedSteps'] &&
                      hotelDetails[0]['completedSteps']['location']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addhotellocation/'
                        ? `${
                            hotelDetails &&
                            hotelDetails.length > 0 &&
                            hotelDetails[0]['completedSteps'] &&
                            hotelDetails[0]['completedSteps']['location']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Location')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {hotelDetails &&
                hotelDetails.length > 0 &&
                hotelDetails[0]['completedSteps'] &&
                hotelDetails[0]['completedSteps']['propertyDetail'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      hotelDetails &&
                      hotelDetails.length > 0 &&
                      hotelDetails[0]['completedSteps'] &&
                      hotelDetails[0]['completedSteps']['propertyDetail']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addhoteldetails/'
                        ? `${
                            hotelDetails &&
                            hotelDetails.length > 0 &&
                            hotelDetails[0]['completedSteps'] &&
                            hotelDetails[0]['completedSteps']['propertyDetail']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addhoteldetails/', {menuId:menuId})}
                    state={{hotelId: editHotelId}}
                  >
                    {t('Property Details')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      hotelDetails &&
                      hotelDetails.length > 0 &&
                      hotelDetails[0]['completedSteps'] &&
                      hotelDetails[0]['completedSteps']['propertyDetail']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addhoteldetails/'
                        ? `${
                            hotelDetails &&
                            hotelDetails.length > 0 &&
                            hotelDetails[0]['completedSteps'] &&
                            hotelDetails[0]['completedSteps']['propertyDetail']
                              ? 'active_tab  text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Property Details')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {hotelDetails &&
                hotelDetails.length > 0 &&
                hotelDetails[0]['completedSteps'] &&
                hotelDetails[0]['completedSteps']['policies'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      hotelDetails &&
                      hotelDetails.length > 0 &&
                      hotelDetails[0]['completedSteps'] &&
                      hotelDetails[0]['completedSteps']['policies']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addhotelpolicies/'
                        ? `${
                            hotelDetails &&
                            hotelDetails.length > 0 &&
                            hotelDetails[0]['completedSteps'] &&
                            hotelDetails[0]['completedSteps']['policies']
                              ? 'active_tab bg-success  text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addhotelpolicies/', {menuId:menuId})}
                    state={{hotelId: editHotelId}}
                  >
                    {t('Policies')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      hotelDetails &&
                      hotelDetails.length > 0 &&
                      hotelDetails[0]['completedSteps'] &&
                      hotelDetails[0]['completedSteps']['policies']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addhotelpolicies/'
                        ? `${
                            hotelDetails &&
                            hotelDetails.length > 0 &&
                            hotelDetails[0]['completedSteps'] &&
                            hotelDetails[0]['completedSteps']['policies']
                              ? 'active_tab  text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Policies')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {hotelDetails &&
                hotelDetails.length > 0 &&
                hotelDetails[0]['completedSteps'] &&
                hotelDetails[0]['completedSteps']['roomAndSpace'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      hotelDetails &&
                      hotelDetails.length > 0 &&
                      hotelDetails[0]['completedSteps'] &&
                      hotelDetails[0]['completedSteps']['roomAndSpace']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/viewrooms/'
                        ? `${
                            hotelDetails &&
                            hotelDetails.length > 0 &&
                            hotelDetails[0]['completedSteps'] &&
                            hotelDetails[0]['completedSteps']['roomAndSpace']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../viewrooms/', {menuId:menuId})}
                    state={{hotelId: editHotelId}}
                  >
                    {t('Room & Spaces')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      hotelDetails &&
                      hotelDetails.length > 0 &&
                      hotelDetails[0]['completedSteps'] &&
                      hotelDetails[0]['completedSteps']['roomAndSpace']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/viewrooms/'
                        ? `${
                            hotelDetails &&
                            hotelDetails.length > 0 &&
                            hotelDetails[0]['completedSteps'] &&
                            hotelDetails[0]['completedSteps']['roomAndSpace']
                              ? 'active_tab  text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Room & Spaces')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {hotelDetails &&
                hotelDetails.length > 0 &&
                hotelDetails[0]['completedSteps'] &&
                hotelDetails[0]['completedSteps']['photos'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      hotelDetails &&
                      hotelDetails.length > 0 &&
                      hotelDetails[0]['completedSteps'] &&
                      hotelDetails[0]['completedSteps']['photos']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addhotelphotos/'
                        ? `${
                            hotelDetails &&
                            hotelDetails.length > 0 &&
                            hotelDetails[0]['completedSteps'] &&
                            hotelDetails[0]['completedSteps']['photos']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addhotelphotos/', {menuId:menuId})}
                    state={{hotelId: editHotelId}}
                  >
                    {t('Photos')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      hotelDetails &&
                      hotelDetails.length > 0 &&
                      hotelDetails[0]['completedSteps'] &&
                      hotelDetails[0]['completedSteps']['photos']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addhotelphotos/'
                        ? `${
                            hotelDetails &&
                            hotelDetails.length > 0 &&
                            hotelDetails[0]['completedSteps'] &&
                            hotelDetails[0]['completedSteps']['photos']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Photos')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {hotelDetails &&
                hotelDetails.length > 0 &&
                hotelDetails[0]['completedSteps'] &&
                hotelDetails[0]['completedSteps']['facilitiesAndServices'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      hotelDetails &&
                      hotelDetails.length > 0 &&
                      hotelDetails[0]['completedSteps'] &&
                      hotelDetails[0]['completedSteps']['facilitiesAndServices']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addhotelfacilities/'
                        ? `${
                            hotelDetails &&
                            hotelDetails.length > 0 &&
                            hotelDetails[0]['completedSteps'] &&
                            hotelDetails[0]['completedSteps']['facilitiesAndServices']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addhotelfacilities/', {menuId:menuId})}
                    state={{hotelId: editHotelId}}
                  >
                    {t('Facilities & Services')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      hotelDetails &&
                      hotelDetails.length > 0 &&
                      hotelDetails[0]['completedSteps'] &&
                      hotelDetails[0]['completedSteps']['facilitiesAndServices']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addhotelfacilities/'
                        ? `${
                            hotelDetails &&
                            hotelDetails.length > 0 &&
                            hotelDetails[0]['completedSteps'] &&
                            hotelDetails[0]['completedSteps']['facilitiesAndServices']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Facilities & Services')}
                  </button>
                )}
              </li>

              <li className='nav-item'>
                {hotelDetails &&
                hotelDetails.length > 0 &&
                hotelDetails[0]['completedSteps'] &&
                hotelDetails[0]['completedSteps']['financeAndLegal'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      hotelDetails &&
                      hotelDetails.length > 0 &&
                      hotelDetails[0]['completedSteps'] &&
                      hotelDetails[0]['completedSteps']['financeAndLegal']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addhotelfinance/'
                        ? `${
                            hotelDetails &&
                            hotelDetails.length > 0 &&
                            hotelDetails[0]['completedSteps'] &&
                            hotelDetails[0]['completedSteps']['financeAndLegal']
                              ? 'active_tab bg-success  text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addhotelfinance/', {menuId:menuId})}
                    state={{hotelId: editHotelId}}
                  >
                    {t('Finance & Legal')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      hotelDetails &&
                      hotelDetails.length > 0 &&
                      hotelDetails[0]['completedSteps'] &&
                      hotelDetails[0]['completedSteps']['financeAndLegal']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addhotelfinance/'
                        ? `${
                            hotelDetails &&
                            hotelDetails.length > 0 &&
                            hotelDetails[0]['completedSteps'] &&
                            hotelDetails[0]['completedSteps']['financeAndLegal']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Finance & Legal')}
                  </button>
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export {AddHotelHeader}
